export default __webpack_public_path__ + "static/media/VC.9b978ae5.svg";